import type { IAdminUserRepository } from '@yawi/domain';
import type {
    AdminUser,
    CreateAdminUserDto,
    UpdateAdminUserDto,
} from '@yawi/types';
import { getApiClient } from '../../http/apiClient';

/**
 * Staff de Hommi (master_users con role SUPER_ADMIN). El backend solo expone
 * GET/POST/PATCH en `admin/users`: no hay delete, invitación ni reenvío.
 */
export class ApiAdminUserRepository implements IAdminUserRepository {
  private readonly basePath = 'v1/admin/users';

  async findAll(): Promise<AdminUser[]> {
    const client = getApiClient();
    // ponytail: una sola página de 100 (MAX_LIMIT del backend); paginar si el staff crece
    const response = await client.get<{ data: AdminUser[] }>(
      `${this.basePath}?role=SUPER_ADMIN&limit=100`,
    );
    return response.data;
  }

  async findById(id: string): Promise<AdminUser> {
    const client = getApiClient();
    return client.get<AdminUser>(`${this.basePath}/${id}`);
  }

  async create(dto: CreateAdminUserDto): Promise<AdminUser> {
    const client = getApiClient();
    // sendInvitation:false deja la cuenta ACTIVE; con invitación quedaría en
    // PENDING_VERIFICATION sin correo y sin poder iniciar sesión.
    return client.post<AdminUser>(this.basePath, {
      ...dto,
      role: 'SUPER_ADMIN',
      sendInvitation: false,
    });
  }

  async update(id: string, dto: UpdateAdminUserDto): Promise<AdminUser> {
    const client = getApiClient();
    return client.patch<AdminUser>(`${this.basePath}/${id}`, dto);
  }
}
